<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'系统配置'},{name:'banner管理',goback:true},{name:sendInfo.id?'编辑banner':'添加banner'}]" :title="sendInfo.id?'编辑banner':'添加banner'"/>
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>banner图片：</div>
                        <div class="content"><upLoad :action="'backstage/annex/file'"  is-need-limit
						@input="inputValue" :accept="'image/png,image/jpg,image/jpeg'" 
						:size="20" :value="sendInfo.bannerImgUrl" :sizeList="this.type === '0'?[16 / 3]:[5 / 3]" :fixedNumber="this.type === '0'?[16,3]:[5,3]"
                                  :autoCropWidth="this.type === '0'?1920:750"
                                  :autoCropHeight="this.type === '0'?360:450"/></div>
                    </div>
                    <div class="hint">{{this.type === '0'?'图片仅支持png、jpg格式，建议尺寸为1920*360px，图片内容安全区域为中心1200*360px':'图片仅支持png、jpg格式，建议尺寸为750*450px'}}</div>
                    <div class="error" v-if="errors['sendInfo.bannerImgUrl']">错误提示：{{errors['sendInfo.bannerImgUrl']}}</div>

                    <div class="child">
                        <div class="name"><span>*</span>banner名称：</div>
                        <el-input v-model="sendInfo.bannerName" maxlength="20" placeholder="限20字"></el-input>
                    </div>
                    <div class="error" v-if="errors['sendInfo.bannerName']">错误提示：{{errors['sendInfo.bannerName']}}</div>

                    <div class="child">
                        <div class="name"><span>*</span>链接：</div>
                        <el-radio-group v-model="sendInfo.linkType">
                            <el-radio :label="0">内部模块</el-radio>
                            <el-radio :label="1">链接地址</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="child">
                        <div class="name"></div>
                        <div class="content">
                          <div class="child childList" v-show="sendInfo.linkType==0" @change="setAddress">
                              <el-radio-group v-model="sendInfo.linkPoint">
                                  <el-radio :label="item.id" v-for="(item,index) in childList" :key="index">{{item.moduleName}}</el-radio>
                              </el-radio-group>
                          </div>
                          <div class="child"  v-show="sendInfo.linkType==1" @input="setAddress">
                        <el-input v-model="sendInfo.linkUrl"></el-input>
                    </div>
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.linkType']">错误提示：{{errors['sendInfo.linkType']}}</div>
                    <div class="child">
                        <div class="name"></div>
                        <div class="content">
                          <div class="singleBtn"><el-button type="primary" size="small" @click="submit">发布</el-button></div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import upLoad from '../../components/upLoads';
export default {
    components:{
        breadcrumb,
        upLoad
    },
    data(){
        return{
            type:void 0,
            id: void 0,
            sendInfo:{
                id:'',
                bannerImgUrl:'',//图片
                bannerName:'',//banner名称
                linkType:null,//链接类型
                linkPoint:null,//内部模块子选项
                linkUrl:'',//链接地址
                type: void 0 // 类型 0 PC， 1：app
            },
            childList:[
                    {moduleName:'首页',id:'1'},
                    {moduleName:'债权产品',id:'2'},
                    {moduleName:'合作银行',id:'3'},
                    {moduleName:'企业融资',id:'4'},
                    {moduleName:'股权项目',id:'5'},
                    {moduleName:'基金合作',id:'6'},
                    {moduleName:'担保服务',id:'7'},
                    {moduleName:'政策资讯',id:'8'},
                    {moduleName:'政策申报',id:'9'},
                    {moduleName:'孵化器',id:'10'},
                    {moduleName:'中介服务',id:'11'},
                    {moduleName:'活动沙龙',id:'12'},
                    {moduleName:'资讯',id:'13'},
                    {moduleName:'企业介绍',id:'14'},
                    {moduleName:'联系我们',id:'15'},
                ],//内部模块子选项数组
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfo.bannerImgUrl':{
            test:function(){
                if(this.sendInfo.bannerImgUrl){
                    return true;
                }else{
                    return false;
                }
            },
            message:'上传banner图片'
        },
        'sendInfo.bannerName':{
            test:function(){
                if(this.sendInfo.bannerName.length>0){
                    return true;
                }else{
                    return false;
                }
            },
            message:'输入banner名称'
        },
        'sendInfo.linkType':{
            test:function(){
                if(this.sendInfo.linkType == 0){
                    if(this.sendInfo.linkPoint){
                        return true;
                    }else{
                        return false;
                    }
                }else{
                    let reg = /(http|https):\/\/([\w.]+\/?)\S*/
                    return reg.test(this.sendInfo.linkUrl)
                }
            },
            message:'选择内部模块或填写链接地址'
        }
    },
    created(){
      const {id ,type} = this.$route.params
      this.id = id || void 0
      this.type = type ||  void 0
      this.sendInfo.id = id || void 0
      this.sendInfo.type = type? parseInt(type) : 0
      if(id) this.getData()

    },
    mounted(){
        // if(this.$route.query.id){
        //     this.sendInfo.id = this.$route.query.id
        //     this.sendInfo.bannerImgUrl = this.$route.query.bannerImgUrl
        //     this.sendInfo.bannerName = this.$route.query.bannerName
        //     this.sendInfo.linkType = this.$route.query.linkType
        //     this.sendInfo.linkPoint = this.$route.query.linkPoint
        //     this.sendInfo.linkUrl = this.$route.query.linkUrl
        // }
        this.$axiosc.get('backstage/banner/internal/module/list').then(res=>{
            if(res.code == 200){
                this.childList = res.data
            }
        })
    },
    methods:{
        //根据选择和输入 重置链接的错误信息
        setAddress:function(){
            this.$vuerify.check(['sendInfo.linkType']);
        },
        inputValue(value){
            this.sendInfo.bannerImgUrl = value
        },
        //发布
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                if(this.sendInfo.linkType == 0){
                    this.sendInfo.linkUrl = null
                }else{
                    this.sendInfo.linkPoint = ''
                }
                this.$axioscBody.post('backstage/banner/save',this.sendInfo).then(res=>{
                    if(res.code == 200){
                        this.$router.back()
                        this.$message({
                            type: 'success',
                            message: this.sendInfo.id?"修改成功":'添加成功!'
                        });
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            }
        },
        async getData(){
          const {code,data,msg} = await this.$axiosc.get(`/backstage/banner/findBanner/${this.id}`)
          if(code === 200) this.sendInfo = Object.assign(this.sendInfo,data)
        }
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:93%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
        padding:100px 0;
    border-top: 1px solid rgba(112, 112, 112, 0.1);
    .forms{
            max-width: 610px;
            margin: auto;
            transform: translateX(-100px);
            .child{
                .name{
                  width:80px;
                  text-align: right;
                  margin-right:10px;
                }
                .content{
                    flex: 1;
					/deep/ .ql-container{
						min-height: 410px;
					}
                }
            }
        }
    }
    .childList{
        max-width: 700px;
        /deep/ .el-radio{
            margin-top: 10px;
            width: 100px;
        }
    }
}
.error{
  text-indent: 95px !important;
}
</style>